import { Icon } from "@/components/common/icon";
import LogoutButton from "@/components/auth/logout-button";
import { getLicensesByCurrentUser } from "@/lib/helpers/licenses";
import { Link, Navigate } from "react-router-dom";
import { getConfigValue } from "@rumble-it/common-lib/src/config";
import { useCurrentUser } from "../../../lib/hooks/useCurrentUser";
import SelectDealership from "../../overview/components/dealership-selection/select-dealership";
import { Card } from "@rumbledirect/ui";

export const LicensesSelect = () => {
  const currentUser = useCurrentUser();

  const licenses = getLicensesByCurrentUser(currentUser);

  // Only evaluate redirects once the current user is loaded. Returning a
  // <Navigate> element (instead of calling navigate() during render) ensures
  // the redirect fires reliably, even when the user is hydrated synchronously
  // from session storage on a full page reload.
  if (currentUser) {
    if (currentUser.permissions.includes("admin_claim_direct_nav")) {
      return <Navigate to="/claims/dashboard" replace />;
    }

    // Users with the V2 (SurveyJS) dealer intake permission are routed straight
    // to that form and never see the license tile-selection screen.
    if (currentUser.permissions.includes("admin_dealer_intake_v2_nav")) {
      return <Navigate to="/dealer-intake-v2" replace />;
    }

    // If there's only one license available, redirect straight to that tile.
    if (licenses.length === 1) {
      return <Navigate to={licenses[0].href} replace />;
    }
  }

  return (
    <div className="h-full w-full flex flex-col items-center pt-64">
      <div className="max-w-4xl flex flex-col items-center">
        <img
          width={0}
          height={0}
          alt="RumbleDirect Logo"
          src={`${getConfigValue("cdnUrl")}/static/assets/logos/logo-rumble.svg`}
          className="max-h-[50%] max-w-[50%] mx-auto"
          style={{ width: "auto", height: "auto" }}
        />

        <div className="mt-8 mr-8 w-60">
          <SelectDealership />
        </div>

        <div className="w-full flex mt-12 justify-evenly">
          {licenses?.map((license) => (
            <Link
              key={license.id}
              className="font-bold text-xl"
              to={license.href}
            >
              <Card className="w-48 text-center hover:text-primary-500 cursor-pointer">
                <Icon
                  faIcon={license.icon}
                  className="w-11 h-11 mx-auto mb-2"
                />
                {license.title}
              </Card>
            </Link>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 mb-8 flex justify-center">
        <LogoutButton />
      </div>
    </div>
  );
};
